import dayjs from "dayjs";

export enum RiskLevel {
  AwarenessLogOnly = "Awareness (Log Only)",
  WatchAndAlign = "Watch & Align",
  ImmediateEscalation = "Immediate Escalation",
}

export const RISK_LEVEL_DISPLAY: Record<
  RiskLevel,
  { readonly dotClassName: string }
> = {
  [RiskLevel.AwarenessLogOnly]: {
    dotClassName: "bg-state-success-100",
  },
  [RiskLevel.WatchAndAlign]: {
    dotClassName: "bg-yellow-200",
  },
  [RiskLevel.ImmediateEscalation]: {
    dotClassName: "bg-state-error-100",
  },
};

export function formatCatchUpDate(lastCatchUp: string): string {
  const parsedCatchUp = dayjs(lastCatchUp);
  return parsedCatchUp.isValid()
    ? parsedCatchUp.format("MMM D, YYYY")
    : lastCatchUp;
}
